export const required=[
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
]

export const employeeStatus=[
  { label: 'Salaried', value: 0 },
  { label: 'Self Employed', value: 1 },
]